import { render, staticRenderFns } from "./AssistantAdd.vue?vue&type=template&id=c4b9a036&"
import script from "./AssistantAdd.vue?vue&type=script&lang=js&"
export * from "./AssistantAdd.vue?vue&type=script&lang=js&"
import style0 from "./AssistantAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports